import axios from 'axios';
import { BS_API_URL } from '../../comm/config';
import { getAuthorization } from '../axios';
import { rewriteHeaderIdByUserRole, rewriteOBJ, rewriteParams } from '../commlogic';

const API_HOST = BS_API_URL;

const POST_LIST = {
  editBsDiagnosis: '/update/bsDiagnosis',
  createBsDiagnosis: '/create/bsDiagnosis',
  deleteBsDiagnosis: '/delete/bsDiagnosis',
  updateBsRemark: '/update/bsRemark',
  createBsRemark: '/create/bsRemark',
  deleteBsRemark: '/delete/bsRemark',
  postCreateBsBooking: '/create/bsTransferRequest',
  postUpdateBsBooking: '/update/bsTransferRequest',
  postCancelDischg: '/cancel/dischg',
  postSaveRemark: '/save/remark',
  postUpdateDischg: '/update/dischg',
  postUpdateStatus: '/update/status',
  postUpdateTbc: '/update/tbc',
  postPatientRetrieve: '/patient/retrieve',
  postBsRemarkList: '/bsRemark/list',
  postBsBedStatusList: '/bsBedStatus/list',
  postSaveReturnDayCase: '/save/retunDayCase',
  postTransferEnableUpdate: '/bsTransferEnable/update',
  postCreateBsTransferOutRequest: '/create/bsTransferOutRequest',
  postUpdateBsTransferOutRequest: '/update/bsTransferOutRequest',
  postDeclineAcceptBsTransferOutRequest: '/execute/bsTransferOutRequest',
  postSaveTransferOut: '/save/transferOut',
  postCancelTransferOut: '/cancel/transferOut',

  // new bed status
  createFloorPlan: '/create/floorPlan',
  updateFloorPlan: '/update/floorPlan',
  updateCubicle: '/update/cubicle',
  updateCubicleBed: '/update/cubicleBed',
  sortLinked: '/sort/linked',
  updateCubicleRemark: '/update/bsCubicleRemark',
  createCubicleRemark: '/create/bsCubicleRemark',
  updateWardRemark: '/update/bsWardRemark',
  createWardRemark: '/create/bsWardRemark',
  updateViewSetting: '/viewSetting/update',
  getHospCleansingSetting: '/hospCleansing/setting',
  updateWardCleansingEnable: '/wardCleansingEnable/update',
  updateWardCodingDetail: '/update/wardCoding',
  updateWardServicesMappingDetail: '/update/wardServicesMapping',
  createCleansing: '/create/cleansing',
  getCleansingList: '/cleansing/list',
  updateCleansingSetting: '/update/cleansingSetting',
  withdrawnCleansing: '/withdrawn/cleansing',
  getCleansingHistory: '/cleansing/history',
  getDischgCleansingList: '/dischgCleansing/list',
  updateDefaultAdmissionTime: '/bsTransferTime/update',
  getQueueList: '/bsBedStatus/queue',

  // service order remark
  createServiceOrderRemark: '/create/bsServiceOrderRemark',
  deleteServiceOrderRemark: '/delete/bsServiceOrderRemark',
  updateServiceOrderRemark: '/update/bsServiceOrderRemark',
};

const GET_LIST = {
  getBsBookingList: '/bsTransferRequest/list',
  getBsMlookupList: '/bsMlookup/list',
  getBsDiagnosisList: '/bsDiagnosis/list',
  getBsRemarkList: '/bsRemark/list',
  getBsBedStatusList: '/bsBedStatus/list',
  getBsBedStatusDetail: '/bsBedStatus/detail',
  getBsHospcodeList: '/bsHospcode/list',
  getIpasHospList: '/ipasHosp/list',
  getBsAttentionList: '/bsAttention/list',
  getBsTransferRequestTbcList: '/bsTransferRequestTbc/list',
  // getExportBsTransferRequest: '/export/bsTransferRequest',
  getBsTransferRequestPendingFYA: '/bsTransferRequest/pendingfya',
  getDownloadMediaResource: '/media/play',
  getBsBedStatuswardCdlist: '/bsBedStatus/wardCd',
  getBsTransferOutRequestlist: '/bsTransferOutRequest/list',
  // getExportBsTransferRequestOutInfo: '/export/bsTransferOutRequest',
  getBsAdmBookingList: '/bsAdmTransferRequest/list',

  getTransferEnabledetail: '/bsTransferEnable/detail',
  getBsTransferOutRequestDetail: '/bsTransferOutRequest/detail',
  getBsBedStatusHospWardList: '/bsBedStatus/hospWard',
  getBsTransferRequestDetail: '/bsTransferRequest/detail',

  // new bed status
  getLocationList: '/location/list',
  getFloorPlanList: '/floorPlan/list',
  getLinkedList: '/linked/list',
  getCubicleList: '/cubicle/list',
  getCubicleRemarkList: '/bsCubicleRemark/list',
  getWardRemarkList: '/bsWardRemark/list',
  getViewSettingDetail: '/viewSetting/detail',
  getFloorPlanLocation: '/floorPlan/location',
  getTransferStatistic: '/bsTransferRequest/statistic',
  getCommandCentreDisplay: '/ssoLink/display',
  getWardCleansingEnable: '/wardCleansingEnable/detail',
  getWardCodingDetail: '/wardCoding/detail',
  getWardServicesMappingDetail: '/wardServicesMapping/detail',
  getWardServicesMappingList: '/wardServicesMapping/list',
  getBsCleansingRemark: '/BsCleansingRemark/list',
  getWardCodingList: '/wardCoding/list',
  getDefaultAdmissionTime: '/bsTransferTime/detail',

  // bed cleansing
  getOrderLocationList: '/orderLocations/list',
  getServiceTypeList: '/orderServiceTypes/list',

  // service order remark
  getServiceOrderRemarkList: '/bsServiceOrderRemark/list',
};

const BEDSTATUSAPI = {
  POST: POST_LIST,
  GET: GET_LIST,
};

rewriteOBJ(BEDSTATUSAPI, API_HOST);

const getExportBsTransferRequest = ({ wardId, ...rest }) => {
  return axios({
    method: 'POST',
    url: `${API_HOST}/export/bsTransferRequest`,
    responseType: 'blob',
    headers: { ...rewriteHeaderIdByUserRole(), Authorization: getAuthorization()?.Authorization || '' },
    data: { wardId, ...rest },
  });
};
const getExportBsTransferRequestOutInfo = ({ wardId, ...rest }) => {
  return axios({
    method: 'POST',
    url: `${API_HOST}/export/bsTransferOutRequest`,
    responseType: 'blob',
    headers: { ...rewriteHeaderIdByUserRole(), Authorization: getAuthorization()?.Authorization || '' },
    data: { wardId, ...rest },
  });
};

const getExportBsAdmTransferRequest = ({ wardId, ...rest }) => {
  return axios({
    method: 'POST',
    url: `${API_HOST}/export/bsAdmTransferRequest`,
    responseType: 'blob',
    headers: { ...rewriteHeaderIdByUserRole(), Authorization: getAuthorization()?.Authorization || '' },
    data: { wardId, ...rest },
  });
};

const getServiceHistoryExportRequest = (params) => {
  return axios({
    method: 'post',
    url: `${API_HOST}/cleansing/export`,
    responseType: 'blob',
    headers: { ...rewriteHeaderIdByUserRole(), Authorization: getAuthorization()?.Authorization || '' },
    data: params,
  });
};

export default {
  ...BEDSTATUSAPI.GET,
  ...BEDSTATUSAPI.POST,
  getExportBsTransferRequest,
  getExportBsTransferRequestOutInfo,
  getExportBsAdmTransferRequest,
  getServiceHistoryExportRequest,
};
